export const STEPS = {
  INITIAL: 0,
  CONNECTION_ADDRESS: 1,
  CONNECTION_PLACEMENT: 2,
  CONNECTION_TYPE: 3,
  CONNECTION_COST: 4,
  EXPECTED_DOWNLOAD_SPEED: 5,
  EXPECTED_UPLOAD_SPEED: 6,
  RUN_SPEED_TEST: 7,
  SPEED_TEST_RESULTS: 8,
  NO_INTERNET: 9
};
